/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_ContactsInputs */

const en_settings_contacts = /** @type {(inputs: Settings_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Contacts`)
};

const he_settings_contacts = /** @type {(inputs: Settings_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אנשי קשר בגוגל`)
};

/**
* | output |
* | --- |
* | "Google Contacts" |
*
* @param {Settings_ContactsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_contacts = /** @type {((inputs?: Settings_ContactsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_ContactsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_contacts(inputs)
	return he_settings_contacts(inputs)
});